module.exports = __webpack_public_path__ + "static/media/banner-factoryKrakow-mobile.a21b785f.jpg";